import GuidedTour from './GuidedTour.connect';

import GuidedTourSagas from './GuidedTour.sagas';
import GuidedTourConstants from './GuidedTour.constants';

GuidedTour.sagas = GuidedTourSagas;
GuidedTour.constants = GuidedTourConstants;

export default GuidedTour;
